import React, { useContext } from "react";
import DeckGL from "@deck.gl/react";
import MapboxMap from "react-map-gl";
import {
  InteractionState,
  PickInfo,
  ViewStateProps,
} from "@deck.gl/core/lib/deck";
import { Layer } from "@deck.gl/core";
import { DarkModeContext } from "../darkModeContext";

const MAPBOX_ACCESS_TOKEN = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;

// Viewport settings
const INITIAL_VIEW_STATE = {
  longitude: 3.95,
  latitude: 58.47,
  zoom: 4,
  pitch: 40,
  bearing: 0,
};

type MapProps = {
  layers: (Layer<any> | undefined | null | false)[];
  getTooltip: (info: PickInfo<any>) => string | undefined;
  onClick?: (info: PickInfo<any>) => void;
  viewState?: ViewStateProps;
  onViewStateChange?: (args: {
    viewState: any;
    interactionState: InteractionState;
    oldViewState: any;
  }) => any;
  lightModeMapStyle?: string
};

function Map(props: MapProps) {
  const [darkMode] = useContext(DarkModeContext);
  return (
    <div style={{ width: "100%", height: "100%", position: "relative", overflow: "hidden" }}>
      <DeckGL
        initialViewState={INITIAL_VIEW_STATE}
        controller={true}
        layers={props.layers}
        getTooltip={props.getTooltip as any}
        viewState={props.viewState}
        onViewStateChange={props.onViewStateChange}
        onClick={props.onClick}
      >
        <MapboxMap
          mapStyle={
            darkMode
              ? `mapbox://styles/kahole/cl8geatbl000b15nrbdnf5gyk`
              : props.lightModeMapStyle ?? `mapbox://styles/kahole/cl8g28svy003n14msyb4ohvgj`
          }
          // mapStyle={`mapbox://styles/mapbox/${darkMode ? 'dark' : 'light'}-v10`}
          mapboxAccessToken={MAPBOX_ACCESS_TOKEN}
        />
      </DeckGL>
    </div>
  );
}

export default Map;
